// @ts-ignore
import pluralize from 'pluralize'
import { Facet } from './Types'
import { FilterSection } from '../../../product-filters/components/sections/filter-section'
import {
  BooleanFacet,
  NumericRangeFacet,
  RatingFacet,
  MultiSelectFacet,
} from './'

interface FacetControlProps {
  isOpen: boolean
  facet: Facet<any>
  onFilterChange: (facetKey: string, selectedOptions: any) => void
  selectedValues: any
}

export const FacetControl = ({
  isOpen = false,
  facet,
  onFilterChange,
  selectedValues,
}: FacetControlProps) => {
  const handleChange = (selectedOptions: any) => {
    onFilterChange(facet.key, selectedOptions)
  }

  let component
  switch (facet.type) {
    case 'boolean':
      component = (
        <BooleanFacet
          facet={facet}
          onChange={handleChange}
          initialValue={selectedValues}
        />
      )
      break
    case 'multi-select':
      component = (
        <MultiSelectFacet
          facet={facet}
          onChange={handleChange}
          initialValues={selectedValues}
        />
      )
      break
    case 'numeric-range':
      component = <NumericRangeFacet facet={facet} onChange={handleChange} />
      break
    case 'rating':
      component = (
        <RatingFacet
          facet={facet}
          onChange={handleChange}
          initialValue={selectedValues}
        />
      )
      break
    default:
      component = <div>Unsupported facet type</div>
      break
  }
  if (facet.type !== 'boolean') {
    return (
      <FilterSection open={isOpen} title={facet.label}>
        {component}
      </FilterSection>
    )
  } else {
    return component
  }
}

export default FacetControl
